import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '@clerk/clerk-react';
import { Navigate, Outlet } from 'react-router';
import { useGetUserQuery, isGlobalAdminUser } from '@/state/queries/users/use-get-user';

/**
 * Route layout: only users signed in with `admin` in `GET /users` globalRoles may render child routes.
 * This is UX + casual misuse protection; the API remains authoritative.
 */
export default function RequireAdminLayout() {
  const { isLoaded, isSignedIn } = useAuth();
  const { data, isPending, isError } = useGetUserQuery();

  if (!isLoaded) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/" replace />;
  }

  if (isPending) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !isGlobalAdminUser(data)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
